<div class="image-asset" [class.show-full-size]="showFullSize" [style.width.px]="width" [style.height.px]="height">
    <div class="image-asset-spinner" [ngClass]="setSpinnerClass()">
        <p-progressSpinner strokeWidth="8" animationDuration="1s" [hidden]="!loading"></p-progressSpinner>
    </div>
    <img *ngIf="hasImage && isFullSizeEnabled" [src]="url" [hidden]="loading" (error)="onImageLoadError()" (mousedown)="toggleOverlay($event)">
    <img *ngIf="hasImage && !isFullSizeEnabled" [src]="url" [hidden]="loading" (error)="onImageLoadError()">
</div>

<p-overlayPanel #overlayPanel styleClass="image-asset-full-size-window" appendTo="body" [showCloseIcon]="true">
    <ng-template pTemplate>
        <img *ngIf="imageAsset.AssetType === AssetType.Image" [src]="imageAsset.fullSizeImageUrl" [hidden]="loading" (error)="onImageLoadError()">
        <iframe *ngIf="safeUrl" width="500" height="500" [src]="safeUrl" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </ng-template>
</p-overlayPanel>
